import React, { Component } from "react";
import PropTypes from "prop-types";
import "./MainMenu.css";
import { Link } from "react-router-dom";
import { lang } from "../../../il8n/lang";
import { connect } from "react-redux";
// import { changeLanguage, changeActiveVid } from '../../../Actions/Index';
import { cdnBase, breakSmall, breakTablet, breakLaptop } from "../../../const";
// import logo from './Images/Logo.png';
import Localebar from "./Localebar";

// import localeIcon from './Images/icon_location.png';
import { toggleInterstitial, changeActiveAudio } from "../../../Actions/Index";
// import { blockedLocales } from '../../../const';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import { HashLink } from "react-router-hash-link";

import ReactGA, { event } from "react-ga";

/**
 * The main application menu.
 * @constructor
 Props:

  - collaspe(boolean): toggle collapsing behaviour
  - centered(boolean): change placement of logo
 */
const logo = `${cdnBase}commingsoon/Logos/mightyexpress_logoTM.png`;
class MainMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props,
      menuClass:
        window.location.pathname.split("/").length == 2 ? "mod-clear" : "",
      lastScrollTop: 0,
      activeClass: "active",
      path: window.location.pathname,
      pathname: window.location.pathname.split("/"),
    };



    this.handleScroll = this.handleScroll.bind(this);
    this.renderMenu = this.renderMenu.bind(this);
    this.renderToggle = this.renderToggle.bind(this);
    this.audioToggle = this.audioToggle.bind(this);

    this.audio = new Audio(this.state.activeAudio.src);
    this.audio.loop = true;
  }

  componentWillMount() {
    // When this component mounts, begin listening for scroll changes
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    // If this component is unmounted, stop listening
    window.removeEventListener("scroll", this.handleScroll);
  }

  componentDidMount() {
    // let menuClass= window.location.pathname.split('/') > 3  ? '' : 'mod-clear' ;
    // path: window.location.pathname
    this.setState({path: window.location.pathname })
    // console.log(this.state.activeAudio, this.props)
  }

  componentDidUpdate() {
    if (this.props.activeAudio.play === true) {
      this.audio.play();
    } else {
      this.audio.pause();
    }
  }

  audioToggle() {
    this.props.dispatch(
      changeActiveAudio(
        this.state.activeAudio.src,
        !this.props.activeAudio.play
      )
    );
  }

  play() {
    this.props.dispatch(changeActiveAudio(this.state.activeAudio.src, true));

    // console.log(this.audio);
    // this.audio.play();
  }

  pause() {
    this.props.dispatch(changeActiveAudio(this.state.activeAudio.src, false));

    // this.audio.pause();
  }

  /**
   * handle scroll
   * @param {event} event
   */

  handleScroll(e) {
    if (this.state.collapse) {
      if (this.state.menuClass !== "active") {
        const currentScrollTop = document.documentElement.scrollTop;

        // let location = useLocation();

        // Set the state of hidden depending on scroll position
        // We only change the state if it needs to be changed
        if (this.state.pathname.length <= 2 && currentScrollTop < 300) {
          // this.setState({ menuClass: 'mod-clear' });
        } else if (
          currentScrollTop > 300 &&
          currentScrollTop > this.state.lastScrollTop
        ) {
          this.setState({ menuClass: "" });
        }
        this.setState({ lastScrollTop: currentScrollTop });
      }
    }
  }
  /**
   * Toggles the main menu.
   * @param {string} requestor - Which element was clicked to initiate this call.
   */
  toggleMainMenu(togglesetting, ishome) {
    // this.setState({menuClass: window.location.pathname.split('/').length <= 2 ? 'mod-clear' : '' })

    if (ishome) {
      this.setState({ menuClass: "mod-clear" });
    } else {
      this.setState({ menuClass: "" });
    }

    let { menuClass } = this.state;
    if (window.innerWidth < breakLaptop) {
      if (menuClass === "active") {
        this.setState({
          menuClass: "",
        });
        this.setState({
          toggleicon: "hide",
        });
      } else {
        if (togglesetting !== "nomobile") {
          this.setState({
            menuClass: "active",
          });

          this.setState({
            toggleicon: "active",
          });
        }
      }
    }
  }

  renderToggle() {
    return (
      <nav
        className="main-menu__toggle"
        onClick={() => this.toggleMainMenu("logo")}
      >
        <FontAwesomeIcon
          className={`bars ${this.state.toggleicon}`}
          icon={faBars}
        />
        <FontAwesomeIcon
          className={`exit ${this.state.toggleicon}`}
          icon={faTimes}
        />
      </nav>
    );
  }
  /**
   * Renders either the centered layout or left aligned layout
   * @returns {jsx} - The nav item
   */
  renderMenu() {
    let { gaToggle } = this.props;
    console.log('lang menu = ', lang.getLanguage(),lang.navigation.mainmenu)

    return (
      <div className="main-menu">
        <Link
          to={`/${lang.getLanguage()}`}
          className="main-menu__logo"
          onClick={() => {
            this.toggleMainMenu("nomobile", true);
            this.setState({ path: "" });
          }}
        >
          <img className="mainlogo" src={logo} alt={lang.brand} />
          <img className="mobilelogo" src={logo} alt={lang.brand} />
        </Link>

        <nav className="main-menu__links">
          <ul>
            <li className={"activeLogo mobileonly"}>
              <Link
                to={`/${lang.getLanguage()}`}
                onClick={() => {
                  this.toggleMainMenu("", true);
                  this.setState({ path: "" });
                }}
              >
                <img src={logo} alt={lang.brand} />
              </Link>
            </li>
            
            {lang.navigation.mainmenu.map((nav, index) =>
              this.getNavItem(index, nav)
            )}
            <li className="musictoggle desktoponly">
              <a onClick={() => this.audioToggle()}>
                {this.props.activeAudio.play && (
                  <div>
                    <img
                      src={`${cdnBase}universal/music-off.svg`}
                      alt="mute"
                    ></img>
                    music off
                  </div>
                )}
                {!this.props.activeAudio.play && (
                  <div>
                    <img
                      src={`${cdnBase}universal/music-on.svg`}
                      alt="play music"
                    ></img>
                    music on
                  </div>
                )}
              </a>
            </li>
            <li>
              <ul className="main-menu__copyright mobileonly">
                <li>
                  <a
                    href={lang.footer.contactLink}
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    {lang.footer.contactUs}
                  </a>
                </li>
                <li>
                  <a
                    href={lang.footer.privacyLink}
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    {lang.footer.privacy}
                  </a>
                </li>
                <li>
                  <a
                    href={lang.footer.termsLink}
                    target="_blank"
                    rel="noreferrer noopener "
                  >
                    {lang.footer.terms}
                  </a>
                </li>
                <li className="main-menu__copyright__socialbox">
                  {lang.home.commingsoon.social.icons.map((icon, index) => (
                    <div
                      className="main-menu__copyright__socialbox__icon"
                      key={`${icon.type}_${index}`}
                    >
                      <a
                        onClick={() => {
                          this.toggleMainMenu("", false);
                          this.props.dispatch(
                            toggleInterstitial(true, icon.link)
                          );
                          if (gaToggle.status) {
                            ReactGA.event({
                              category: "socialoutbound",
                              action: "leave",
                              value: icon.type,
                            });
                          }
                        }}
                        target="_blank"
                      >
                        <img
                          className="main-menu__copyright__socialbox__icon__static"
                          src={`${icon.img}`}
                        />
                        <img
                          className="main-menu__copyright__socialbox__icon__hover"
                          src={`${icon.img2}`}
                        />
                      </a>
                    </div>
                  ))}
                </li>
                {/* <li>
                  <a href={lang.footer.supportLink} target="_blank">
                    {lang.footer.support}
                  </a>
                </li> */}
              </ul>
            </li>
          </ul>
        </nav>

        <div className="musictoggle mobileonly">
          <a onClick={() => this.audioToggle()}>
            {this.props.activeAudio.play && (
              <div>
                <img src={`${cdnBase}universal/music-off.svg`} alt="mute"></img>
              </div>
            )}
            {!this.props.activeAudio.play && (
              <div>
                <img
                  src={`${cdnBase}universal/music-on.svg`}
                  alt="play music"
                ></img>
              </div>
            )}
          </a>
        </div>

        {this.renderToggle()}
      </div>
    );
  }
  /**
   * Gets the nav item. Supports 4 types in nav.type : 'internal','internal_hash','external','interstitial' & 'function'.
   * @param {int} index - Current item index.
   * @param {json} nav - Nav item properties.
   * @returns {jsx} - The nav item
   */
  getNavItem(index, nav) {
    let { retailersModal } = this.props;
    let mobileOnly = nav.mobileOnly ? "mobile" : "";
    let activeClass = this.state.path.includes(nav.href) ? "active" : "";

    switch (nav.type) {
      case "internal":
        return (
          <li
            key={`navigation-${index}`}
            className={`${mobileOnly} ${activeClass}`}
          >
            <Link
              to={`/${lang.getLanguage()}${nav.href}`}
              onClick={() => {
                this.toggleMainMenu("", false);
                this.setState({ path: nav.href });
              }}
            >
              <span>{nav.display}</span>
            </Link>
          </li>
        );
      case "internal_hash":
        return (
          <li
            key={`navigation-${index}`}
            className={`${mobileOnly} ${activeClass}`}
          >
            <HashLink
              smooth
              to={`/${lang.getLanguage()}${nav.href}`}
              onClick={() => {
                this.toggleMainMenu("", false);
                this.setState({ path: nav.href });
              }}
            >
              <span>{nav.display}</span>
            </HashLink>
          </li>
        );
      case "external":
        return (
          <li
            key={`navigation-${index}`}
            className={`${mobileOnly} ${activeClass}`}
          >
            <a
              href={nav.href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                this.toggleMainMenu("", false);
                this.setState({ path: nav.href });
              }}
            >
              <span>{nav.display}</span>
            </a>
          </li>
        );
      case "interstitial":
        return (
          <li
            key={`navigation-${index}`}
            className={`${mobileOnly} ${activeClass}`}
          >
            <a
              onClick={() => {
                this.props.dispatch(toggleInterstitial(true, nav.href));
                {
                  this.toggleMainMenu("", false);
                  this.setState({ path: nav.href });
                }
              }}
              rel="noopener noreferrer"
            >
              <span>{nav.display}</span>
            </a>
          </li>
        );
      case "soon":
        return (
          <li
            key={`navigation-${index}`}
            className={`${mobileOnly} disabled soon`}
          >
            <a>
              <span>
                {nav.display} ({nav.alttext}){" "}
              </span>
            </a>
          </li>
        );
      case "function":
        return (
          <li
            key={`navigation-${index}`}
            className={`${mobileOnly} ${activeClass}`}
          >
            <a onClick={retailersModal} rel="noopener noreferrer">
              <span>{nav.display}</span>
            </a>
          </li>
        );
      default:
        console.error(new Error("Nav items must specify type."));
    }
  }

  render() {
    let { menuClass } = this.state;
    return (
      <header className={menuClass}>
        <Localebar/>
        <div className="wrap">{this.renderMenu()}</div>
      </header>
    );
  }
}

function mapStateToProps(state) {
  return {
    lang: state.lang,
    activeAudio: state.activeAudio,
    gaToggle: state.gaToggle,
  };
}

MainMenu.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(MainMenu);



// WEBPACK FOOTER //
// ./src/components/Navs/MainMenu/MainMenu.js